











import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'
import { vue3Model } from '~/utils/nuxt3-migration'
import { Option } from '~/models/shared/types'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  components: { CRadioButtonGroup },
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const yesOrNo = ref(props.modelValue)
    const { t } = useI18n()

    watch(
      () => props.modelValue,
      newValue => {
        yesOrNo.value = newValue
      }
    )

    watch(yesOrNo, newValue => {
      emit('update:modelValue', newValue)
    })

    const options = computed((): Option[] => [
      {
        label: t('no'),
        value: false
      },
      {
        label: t('yes'),
        value: true
      }
    ])

    return {
      yesOrNo,
      options
    }
  }
})
